export const packageStreamingEnvironmentList = [
  { id: 'WindowsServer2003R2', value: 'WindowsServer2003R2' },
  { id: 'Windows98', value: 'Windows98' },
]
